import Notes from "./notes"

export default Notes
